import { dynamicPx, TitleTypography } from 'components/common/Common';
import React from 'react';
import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';
import { FlexDisplay, InfoIcon, SectionContainer } from '../JetSale.style';

const InfoIconP = styled(InfoIcon)`
  position: absolute;
  bottom: -10%;
  left: max(-10.5vw, -9em);

  transform: rotate(90deg);

  @media (max-width: 768px) {
    bottom: 25%;
    left: 74.5vw;
  }
`;

const BannerTextBox = styled.div`
  position: relative;
  background: var(--primary-color);
  flex: 1;
  padding: ${dynamicPx({ minSize: 88 - 38, maxSize: 88, minVW: 720 })} 1em 1.5em;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  @media (max-width: 768px) {
    width: 67vw;
    align-items: end;
    padding: 1em 1em 0.5em;
    ${flexGap('1em')}
    text-align: right;
  }
`;

const Banner = styled(FlexDisplay)`
  &::before {
    content: '';
    position: absolute;
    top: 0;
    width: 20%;
    height: 100%;
    background: linear-gradient(90deg, var(--primary-color) 0%, rgba(0, 99, 219, 0) 100%);
  }
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const BannerImg = styled.img`
  min-height: 12.5em;
  width: 70%;
  object-fit: cover;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const BannerTitleText = styled(TitleTypography)`
  font-family: 'Genuine';
`;

const JText = styled.span`
  font-family: inherit;
  color: var(--primary-color);
  font-weight: 700;
  position: absolute;
  left: -4.5vw;

  @media (max-width: 768px) {
    position: unset;
    color: var(--white);
    font-weight: 400;
    left: 0;
  }
`;

const JetSaleBanner = () => {
  return (
    <SectionContainer>
      <Banner>
        <BannerImg src={'/imgs/webp/jetSale/jetSale-banner.webp'} alt="jet Sale-banner" />
        <BannerTextBox>
          <BannerTitleText
            style={{ lineHeight: 1 }}
            $minSize={36}
            $maxSize={160}
            $color="#fff"
            fontWeight={400}
          >
            JET SALES
          </BannerTitleText>

          <span style={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '20px', fontWeight: 400 }}>
            {'"OWN A JET AND ENJOY THE JOURNEY"'}
          </span>
          <InfoIconP $dynamicSize={{ minSize: 64, maxSize: 120 }}>
            <img src={'/imgs/svg/downward-pointer.svg'} alt="downward-left-pointer" />
          </InfoIconP>
        </BannerTextBox>
      </Banner>
    </SectionContainer>
  );
};

export default JetSaleBanner;
